export const blockIconsNavigationFullscreen = (
	<span className='material-symbols-outlined'>fullscreen</span>
);
